import { useNavigate, useParams } from "react-router-dom";
import { NEWS_LIST_ROUTE, NEWS_UPDATE_ROUTE } from "constants/routeEnum";
import callApi from "Common/utils/apiCaller";
import * as Yup from "yup";
import { X } from "lucide-react";
import { useFormik } from "formik";
import { showNotification } from "Common/utils/Notification";
import { useEffect, useState } from "react";
import { TailSpin } from "react-loader-spinner";
import { imageUploader } from "Common/utils/imageUploader";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import { getImageUrl } from "Common/utils/ImageDomain";
import PermissionSwitch from "../../Common/Components/PermissionLocks/PermissionSwitch";
import { ToastContainer } from "react-toastify";
import BreadCrumb from "Common/BreadCrumb";
import { validateURL } from "Common/utils/Validation";
import LoaderComponent from "Common/Components/Loader/Loader";
import moment from "moment";
import CustomDateInput from "Common/Components/InputFields/CustomDateInput";
import MetaData from "Common/MetaData";
import Drawer from "Common/Components/Drawer";
import ImageView from "Common/Components/ImageView/ImageView";
import ImageData from "Common/Components/customImage/Image";
import CustomInput from "Common/Components/InputFields/CustomInput";

const UpdateNews = () => {
  const navigate = useNavigate();
  const [showApprove, setShowApprove] = useState(false);
  const [version, setVersion] = useState<any>();
  const [loading, setLoading] = useState<any>(false);
  const [newsHeading, setNewsHeading] = useState<any>("");
  const [formData, setFormData] = useState<any>({ released_at: "" });
  const [newsDate, setNewsDate] = useState<any>(moment().toISOString());
  const [newsDateError, setNewsDateError] = useState<any>("");
  const [newsHeadingError, setNewsHeadingError] = useState<any>("");
  const [newsLinkError, setNewsLinkError] = useState<any>("");
  const [newsLink, setNewsLink] = useState<any>("");
  const [loader, setLoader] = useState<any>(false);
  const { id } = useParams();
  const [imageLink, setImageLink] = useState<any>();
  const [content, setContent] = useState<any>();
  const [newsData, setnewsData] = useState<any>();
  const [imageData, setImageData] = useState<any>("");
  const [showMeta, setShowMeta] = useState<any>(false);
  const toggleMeta = () => setShowMeta(!showMeta);
  const [metaEdit, setMetaEdit] = useState<any>({
    url: "",
    page_title: "",
    meta_description: "",
    meta_keyword: "",
    canonical_url: "",
  });
  const [errors, setErrors] = useState<any>();
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);

  interface PermissionInfo {
    permissions: string[];
  }

  const rawPermission = localStorage.getItem("permission");
  const premissionInfo: PermissionInfo | null = rawPermission
  ? JSON.parse(rawPermission)
  : null;

  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.content_type?.split("/")[0] === "image") {
        setImageLink(imageData);
      } else {
        showNotification("Please Select Image", "error");
      }
    }
  }, [imageData]);

  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      permission: profile.permission,
      user: profile.user,
    })
  );

  const { permission, user } = useSelector(selectProperties);

  const userHasPermission = () => {
    return permission?.permissions?.includes("news:edit");
  };


  const userHasPermissionToApprovePage = () => {
    return permission?.permissions?.includes("news:verify");
  };

  const userHasPermissionToPublishPage = () => {
    return permission?.permissions?.includes("news:publish");
  };

  const hasEditMode = () => {
    return newsData?.is_edit;
  };

  const hasApproved = () => {
    return newsData?.is_approved;
  };


  async function fetchNews(id: any) {
    try {
      const res = await callApi(`v1/news/${id}`, "get", {});
      if (res && res?.status === "Success") {
        setNewsLink(res.data.news.external_link);
        setImageLink(res.data.news);
        setContent(res.data.news.text ?? "");
        setnewsData(res.data.news);
        setMetaEdit(res.data.news);
        setNewsDate(res.data.news.released_at);
        setNewsHeading(res.data.news.heading);
      }
    } catch (e) {
      showNotification("something went wrong", "error");
    }
  }

  useEffect(() => {
    if (id) {
      fetchNews(id);
      fetchVersionList(id);
    }
  }, [id]);

  const fetchVersionList = async (id) => {
    try {
      const res = await callApi(`v1/news/${id}/version-list`, "get", {});
      if (res && res?.status === "Success") {
        setVersion(res.data?.copies);
      }
    } catch (e) {
      showNotification("Error occured", "error");
    }
  };

  const showError = (keyName) => {
    return errors && errors[keyName] ? (
      <p className="text-red-500 text-[14px]  pt-2">{errors[keyName]}</p>
    ) : null;
  };

const handleMetaChange = (keyName, keyValue) => {
  setMetaEdit((prev) => ({
    ...prev,
    [`updated_${keyName}`]: keyValue,
    is_meta_edited: true, 
  }));
  setErrors((prev) => ({
    ...prev,
    [`updated_${keyName}`]: "",
  }));
};

  const handleValidate = (data: any) => {
    let isValid = true;
    let error: { [index: string]: any } = {};
    if (!data?.url || data?.url === "") {
      isValid = false;
      error["url"] = "Please enter url";
    }
    // if (!data?.canonical_url || data?.canonical_url === "") {
    //   isValid = false;
    //   error["canonical_url"] = "Please enter canonical url";
    // }
    if (!data?.page_title || data?.page_title === "") {
      isValid = false;
      error["page_title"] = "Please enter page title";
    }
    if (!data?.meta_description || data?.meta_description === "") {
      isValid = false;
      error["meta_description"] = "Please enter meta description";
    }
    // if (!data?.meta_keyword || data?.meta_keyword === "") {
    //   isValid = false;
    //   error["meta_keyword"] = "Please enter meta keyword";
    // }
    return {
      isValid,
      error,
    };
  };
  const handleMetaData = async () => {
    let check = handleValidate(metaEdit);
    if (check.isValid) {
      try {
        const res = await callApi(
          `v1/news/${newsData?.url}/update-news`,
          "post",
          {
            ...metaEdit,
          }
        );
        if (res && res?.status === "Success") {
          showNotification("Updated successfully", "success");
          toggleMeta();
        }
      } catch (e) {
        showNotification(
          e.response.data.data.message || "Error occured",
          "error"
        );
      }
    } else {
      setErrors(check.error);
    }
  };

  const handlePublish = async (url: any) => {
    const res = await callApi(`v1/news/${url}/publish-news`, "get", {});
    if (res && res?.status === "Success") {
      fetchNews(id);
      showNotification("Published successfully", "success");
      setShowApprove(false);
    } else {
      showNotification(res?.data?.message || "Error occured", "error");
    }
  };
  const handleApprove = async () => {
    if (!newsData) {
      showNotification("Page data is missing. Please try again.", "error");
      return;
    }
    try {
      const response = await callApi(
        `v1/news/url/${newsData?.url}/approve`,
        "get"
      );
      if (response?.status === "Success") {
        setLoader(!loader);
        showNotification("Page approved successfully", "success");

        setShowApprove(true);
      }
    } catch (error) {
      showNotification(
        "An error occurred while publishing the page. Please try again.",
        "error"
      );
    }
  };

  const validateNews = () => {
    let isValid = true;
    if (!newsLink) {
      setNewsLinkError("Please enter link");
      isValid = false;
    }
    if (!newsDate) {
      setNewsDateError("Please select news date");
      isValid = false;
    }
    if (!newsHeading) {
      setNewsHeadingError("Please enter heading");
      isValid = false;
    }
    return isValid;
  };

  const handleSubmit = async () => {
    if (validateNews()) {
      // if (!!!imageLink?.media_url && !!!imageLink?.thumbnail_url) {
      //   showNotification("Please add image", "error");
      //   return;
      // }
      try {
        setLoading(true);
        const res = await callApi(
          `v1/news/${newsData?.url}/update-news`,
          "post",
          {
            external_link: newsLink,
            heading: newsHeading,
            released_at: newsDate,
            // ...formData,
            thumbnail_url: imageLink?.media_url || imageLink?.thumbnail_url,
            thumbnail_media_id: imageLink?._id,
          }
        );
        setLoading(false);
        if (res && res?.status === "Success") {
          showNotification("News updated successfully", "success");
          setLoading(true);
          setTimeout(() => {
            navigate(NEWS_LIST_ROUTE);
            setLoading(false);
          }, 500);
        }
      } catch (e) {
        showNotification("something went wrong", "error");
        setLoading(false);
      }
    }
  };

  return (
    <>
      <div className="flex justify-between mt-2">
        <BreadCrumb
          title={`/content/news/${id}/update`}
          pageTitle={NEWS_LIST_ROUTE}
          version="v1"
        />
        <div className="flex gap-2 mt-2 mb-2">
        {userHasPermissionToApprovePage() &&
            hasEditMode() &&!showApprove && (
            <div
              className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              onClick={handleApprove}
            >
              Approve
            </div>
          )}

{userHasPermissionToPublishPage() && showApprove && hasApproved() && (
                <button
                  type="button"
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  onClick={() => {
                    handlePublish(newsData?.url);
                  }}
                >
                  <span className="align-middle">Publish</span>
                </button>
              )
            }
          
          <button
            type="button"
            className="ml-2 text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            onClick={() => toggleMeta()}
          >
            <span className="align-middle">Edit Meta</span>
          </button>
        </div>
      </div>
      <ToastContainer />
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="p-6">
            <form
              className="create-form"
              id="create-form"
              onSubmit={(e) => {
                if (userHasPermission()) {
                  e.preventDefault();
                  handleSubmit();
                } else {
                  showNotification(
                    "You don't have permission to update news",
                    "error"
                  );
                }
                return false;
              }}
            >
              <input type="hidden" value="" name="id" id="id" />
              <input type="hidden" value="add" name="action" id="action" />
              <input type="hidden" id="id-field" />
              <div
                id="alert-error-msg"
                className="hidden px-4 py-3 text-sm text-red-500 border border-transparent rounded-md bg-red-50 dark:bg-red-500/20"
              ></div>
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-12">
                  <CustomDateInput
                    isVersioned={version?.released_at ? true : false}
                    versionedValue={version?.released_at} // Default empty string if not defined
                    isDisabled={!userHasPermission()}
                    value={newsDate}
                    dateOptions={{ dateFormat: "Y-m-d" }}
                    isRequired={true}
                    keyName="released_at"
                    label="News Date"
                    setDate={(selectedDates) => {
                      setNewsDate(selectedDates[0].toISOString());
                    }}
                    placeholder="Select Date"
                    errors={{ released_at: newsDateError }}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-12">
                  <CustomInput
                    label="Heading"
                    name="heading"
                    disabled={!userHasPermission()}
                    type="text"
                    placeholder="Enter heading"
                    onChange={(e) => setNewsHeading(e.target.value)}
                    value={newsHeading || ""}
                    isVersioned={version?.heading ? true : false}
                    versionedValue={version?.heading}
                  />

                  {newsHeadingError ? (
                    <p className="text-red-400">{newsHeadingError}</p>
                  ) : null}
                </div>

                <div className="mt-4 xl:col-span-12">
                  <CustomInput
                    label="Link"
                    name="external_link"
                    disabled={!userHasPermission()}
                    type="text"
                    placeholder="Enter Link"
                    onChange={(e) => setNewsLink(e.target.value)}
                    value={newsLink || ""}
                    isVersioned={version?.external_link ? true : false}
                    versionedValue={version?.external_link}
                  />
                  {newsLinkError ? (
                    <p className="text-red-400">{newsLinkError}</p>
                  ) : null}
                </div>
              </div>
              {/* <div className="m-4 ml-0 xl:col-span-12">
                {imageLink ? (
                  <div className="flex items-center">
                    <ImageData
                      imageLink={imageLink}
                      setImageLink={setImageLink}
                      setImageData={setImageData}
                    />
                    <div className="h-3 ml-3">
                      <div
                        onClick={() => {
                          setImageData(undefined);
                          toggleImage();
                        }}
                        className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      >
                        Change
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div
                      onClick={() => {
                        setImageData(undefined);
                        toggleImage();
                      }}
                      className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    >
                      {"Add Thumbnail"}
                    </div>
                  </>
                )}
              </div> */}
              {/* <div className="xl:col-span-12">
                <CustomDateInput
                  value={formData?.released_at || ""} // Default to empty string if undefined
                  dateOptions={{ dateFormat: "Y-m-d" }}
                  isRequired={true}
                  keyName="released_at"
                  label="Release Date"
                  setDate={(selectedDates) => {
                    if (selectedDates && selectedDates[0]) {
                      setFormData((prev) => ({
                        ...prev,
                        released_at: selectedDates[0].toISOString(),
                      }));
                    }
                  }}
                  isVersioned={version?.released_at ? true : false}
                  versionedValue={version?.released_at} // Default empty string if not defined
                  placeholder="Select Date"
                  errors={""}
                />
              </div> */}
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="reset"
                  id="close-modal"
                  data-modal-close="addEmployeeModal"
                  className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                  onClick={() => navigate(NEWS_LIST_ROUTE)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading || !userHasPermission()}
                  id="addNew"
                  style={{
                    minWidth: "130px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  {loading ? (
                    <span>
                      <TailSpin
                        visible={true}
                        height="20"
                        width="20"
                        color="#fff"
                      />
                    </span>
                  ) : (
                    "Update news"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Drawer
        show={showMeta}
        onHide={toggleMeta}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Edit"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <MetaData
            handleMetaChange={handleMetaChange}
            modelName="news"
            metaEdit={metaEdit}
            showError={showError}
            toggleMeta={toggleMeta}
            handleMetaData={handleMetaData}
            loader={loader}
          />
        </Drawer.Body>
      </Drawer>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default UpdateNews;
